import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { trackPageview } from "../lib/analytics";

export default function RouteChangeTracker() {
  const location = useLocation();

  useEffect(() => {
    trackPageview();
  }, [location.pathname, location.search]);

  return null;
}
